module.exports = __webpack_public_path__ + "img/articleJeResteActive.d50345af.png";